import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { DataPropertyImplementationState } from "./model";

let state: DataPropertyImplementationState = {
  dataPropertyImplementation: {
    id: '',
    dataImplementationId: '',
    index: null,
    dataPropertyDefinitionId: '',
    localId: '',
    defaultValue: null,
    remarks: null,
    publishing: false,
    status: null
  },
  dataPropertyImplementations: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<DataPropertyImplementationState, RootStateType>;
